module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-18-f807f3cc512cc61e573bc178e22c8665.jpg";